import { combineReducers } from 'redux';

import context from './context';
import conversations from './conversations';
import messages from './messages';

/**
 * @typedef {{
 *   context: import('./context').ConversationContextEntity,
 *   conversations: ChatDataConversationByIdReducer,
 *   messages: import("./messages").ChatDataMessageByIdReducer,
 * }} ChatDataReducer
 */

export default combineReducers({
  context,
  messages,
  conversations,
});
